module.exports = __webpack_public_path__ + "static/media/My-Holds.c65d5a77.svg";